import { graphql } from "relay-runtime"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { useMarkAllThreadMessagesAsReadMutation as useMarkAllThreadMessagesAsReadMutationType } from "@/modules/chats/services/__generated__/useMarkAllThreadMessagesAsReadMutation.graphql"

const mutation = graphql`
  mutation useMarkAllThreadMessagesAsReadMutation($input: MarkAllThreadMessagesAsReadInput!) {
    markAllThreadMessagesAsRead(input: $input) {
      markThreadReadOutput {
        threadId
      }
      errors {
        ... on ChatThreadNotFound {
          threadId
          message
        }
      }
    }
  }
`

export const useMarkAllThreadMessagesAsReadMutation = () => {
  return useMutationWithErrorToast<useMarkAllThreadMessagesAsReadMutationType>(mutation)
}
